import React from 'react';
import styled from 'styled-components';

import ArrowDownIcon from '../../../../Icons/ArrowDownIcon';

type IHotelDetailsHeader = {
  openStatus: boolean;
};

const HotelDetailsHeader: React.FC<IHotelDetailsHeader> = ({openStatus, setOpen}) => (
  <PaymentBlockOuterWrapDiv>
    <DetailsHeaderMainWrapDiv>
      <PricingTxtSpan>HOTEL INFO</PricingTxtSpan>
      <CircularDiv onClick={() => setOpen(state => !state)}>
        <ArrowDownNewWrap transformstyle={openStatus ? 'rotate(180deg)' : 'rotate(0deg)'} />
      </CircularDiv>
    </DetailsHeaderMainWrapDiv>
  </PaymentBlockOuterWrapDiv>
);

export default HotelDetailsHeader;

const PaymentBlockOuterWrapDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    width:100%;
    padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l20};
  `
);

const DetailsHeaderMainWrapDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    width:100%;
    justify-content:space-between;
    align-items: center;
  `
);

const PricingTxtSpan = styled.span(
  props => `
    font-weight: ${props.theme.font.fontWeight.black};
    font-size:${props.theme.font.large.font18};
    color: ${props.theme.colors.black.base};
  `
);

const ArrowDownNewWrap = styled(ArrowDownIcon)(
  props => `
    width:1rem;
    height:1rem;
    fill: ${props.theme.colors.blue.base};
    margin-top:${props.theme.spacing.small.s8};
    margin-left:${props.theme.spacing.small.s8};
    position:absolute;
    transform: ${props.transformstyle};
    transition: transform 0.5s;
  `
);

const CircularDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    width:2.6rem;
    height:2.6rem;
  `
);
